import axios from 'axios'
import router from '../router/index'
import store from '../store/index'
import { Message } from 'element-ui';
import './../assets/icon/iconfont.css'

// const service = axios.create({
//     baseURL:'https://api.ibeisai.com/',
//     timeout: 60 * 1000,
//     headers: {'Content-Type':'application/x-www-form-urlencoded'},
// })
// 配置接口地址
axios.defaults.baseURL='https://api.xafa.ibeisai.com'
//图片上传地址
store.dispatch('uploadimage', "https://api.xafa.ibeisai.com/common/upload")
// 请求超时时间
axios.defaults.timeout = 60000
// 请求头设置
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

//请求拦截器
axios.interceptors.request.use(
    config => {
        if (localStorage.getItem('token')) {
            config.headers.Authorization = localStorage.getItem('token');
        }
            return config;
        },
    error => {
        return Promise.reject(error);
});    
//响应拦截器
axios.interceptors.response.use(response => { 
    if (response.status === 200) {
        if(response.data.code==401){
            Message.error({
                message: "登录过期，请重新登录",
                description: "登录过期，请重新登录"
            });
        }
        return Promise.resolve(response);
    } else {
        return Promise.reject(response);
    }
},error => { 
    if (error.response.status) {
        switch (error.response.status) {
            // 401: 未登录
            // 未登录则跳转登录页面，并携带当前页面的路径
            // 在登录成功后返回当前页面，这一步需要在登录页操作。
            case 401:
                Message.error({
                    message: "登录过期，请重新登录",
                    description: "登录过期，请重新登录"
                });
                router.push('/login')
                break;
            // 403 token过期
            // 登录过期对用户进行提示
            // 清除本地token和清空vuex中token对象
            // 跳转登录页面
            case 403:
                Message.error({
                    message: "登录过期，请重新登录",
                    description: "登录过期，请重新登录"
                });
                router.push('/login')
                break;
        }
        return Promise.reject(error.response);
    }
})
// export default service

//get封装方法
export function get(url, params) {
    return new Promise((resolve,reject) => {
        axios.get(url,params).then(res => {
            resolve(res.data)
        }).catch(err=>{
            reject(err.data)
        })
    })
}


//post封装方法
export function post(url, params) {
    return new Promise((resolve,reject) => {
        axios.post(url,params).then(res => {
            resolve(res.data)
        }).catch(err=>{
            reject(err.data)
        })
    })
}


//put封装方法
export function put(url, params) {
    return new Promise((resolve,reject) => {
        axios.put(url,params).then(res => {
            resolve(res.data)
        }).catch(err=>{
            reject(err.data)
        })
    })
}